import { render } from "./LoginPopUpComponent.vue?vue&type=template&id=13abfd5c&scoped=true"
import script from "./LoginPopUpComponent.vue?vue&type=script&lang=js"
export * from "./LoginPopUpComponent.vue?vue&type=script&lang=js"

import "./LoginPopUpComponent.vue?vue&type=style&index=0&id=13abfd5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13abfd5c"]])

export default __exports__